import { render } from "./rowEdit.vue?vue&type=template&id=88837708"
import script from "./rowEdit.vue?vue&type=script&lang=ts"
export * from "./rowEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script